// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_k5-0";
export var discountCodeInput = "_k5-1";